export enum SortOrderEnum {
  ASC = 'asc',
  DESC = 'desc',
}

export enum SortTypeEnum {
  CREATED_AT = 'CreatedAt',
  RECORD_TYPE = 'RecordType',
  EQUIPMENT = 'Equipment',
  CREATED_BY = 'CreatedBy',
  LOG_DATE_ACCEPTING = 'LogDateAccepting',
  LOG_DATE_TRANSFER = 'LogDateTransfer',
  EXECUTOR_FULL_NAME = 'ExecutorFullName',
}
